import React from "react";
import TrueIcon from "../components/Icons/True";
import FalseIcon from "../components/Icons/False";
import { StyledPricing } from "../components/Styles";
import Consultation from "../components/Consultation";
import { useTranslation } from "react-i18next";

const SeoPricing = () => {
  const { t, i18n } = useTranslation();

  return (
    <StyledPricing.Container>
      <StyledPricing.Content>
        <StyledPricing.Description>
          <p>
            <StyledPricing.Title lang={i18n.language}>
              {t("seoPricing.title")}
            </StyledPricing.Title>

            {t("seoPricing.intro1")}
            <br />
            {t("seoPricing.intro2")}
            <br />
            {t("seoPricing.intro3")}
            <br />

            <ul>
              <li>
                <TrueIcon color={"#caa037"} width={14} height={14} />
                <span>{t("seoPricing.models.keyword")}</span>
              </li>
              <li>
                <TrueIcon color={"#caa037"} width={14} height={14} />
                <span>{t("seoPricing.models.traffic")}</span>
              </li>
            </ul>

            {t("seoPricing.conclusion")}
          </p>
        </StyledPricing.Description>
      </StyledPricing.Content>

      <StyledPricing.PricingTable>
        <StyledPricing.Table >
          <thead>
            <StyledPricing.HeaderRow>
              <StyledPricing.HeaderCell></StyledPricing.HeaderCell>
              <StyledPricing.HeaderCell>
                {t("seoPricing.table.basic")}
              </StyledPricing.HeaderCell>
              <StyledPricing.HeaderCell>
                {t("seoPricing.table.standard")}
              </StyledPricing.HeaderCell>
            </StyledPricing.HeaderRow>
          </thead>

          <tbody>
            {[
              ["technicalAudit", "basicAudit", "fullAudit"],
              ["keywordResearch", "fiveKeywords", "tenKeywords"],
              ["contentCreation", "twoMonth", "fourMonth"],
              ["socialSetup", "twoPlatforms", "fourPlatforms"],
              ["socialContent", "twoWeek", "fourWeek"],
              ["reporting", "monthly", "biWeekly"],
              ["rankReport", "quarterly", "monthly"],
            ].map(([label, basic, standard]) => (
              <StyledPricing.Row key={label}>
                <StyledPricing.Cell lang={i18n.language}>
                  {t(`seoPricing.table.${label}`)}
                  <span></span>
                </StyledPricing.Cell>
                <StyledPricing.Cell>
                  {t(`seoPricing.table.${basic}`)}
                </StyledPricing.Cell>
                <StyledPricing.Cell>
                  {t(`seoPricing.table.${standard}`)}
                </StyledPricing.Cell>
              </StyledPricing.Row>
            ))}

            {/* Icon Rows */}
            {[
              "internalLinking",
              "onPage",
              "graphicDesign",
              "localSeo",
              "gmb",
              "mobileFirst",
            ].map((label) => (
              <StyledPricing.Row key={label}>
                <StyledPricing.Cell lang={i18n.language}>
                  {t(`seoPricing.table.${label}`)}
                  <span></span>
                </StyledPricing.Cell>
                <StyledPricing.Cell>
                  <TrueIcon />
                </StyledPricing.Cell>
                <StyledPricing.Cell>
                  <TrueIcon />
                </StyledPricing.Cell>
              </StyledPricing.Row>
            ))}

            {/* Link Building */}
            <StyledPricing.Row>
              <StyledPricing.Cell lang={i18n.language}>
                {t("seoPricing.table.linkBuilding")}
                <span></span>
              </StyledPricing.Cell>
              <StyledPricing.Cell>
                <FalseIcon />
              </StyledPricing.Cell>
              <StyledPricing.Cell>
                <TrueIcon />
              </StyledPricing.Cell>
            </StyledPricing.Row>

            {/* Price */}
            <StyledPricing.Row>
              <StyledPricing.Cell></StyledPricing.Cell>
              <StyledPricing.Cell>{t("seoPricing.table.price-basic")}</StyledPricing.Cell>
              <StyledPricing.Cell>{t("seoPricing.table.price-standard")}</StyledPricing.Cell>
            </StyledPricing.Row>
          </tbody>
        </StyledPricing.Table>
      </StyledPricing.PricingTable>

      <div>
        <Consultation text={
          <>
            {t("customPackage")}
            <br />
            {t("contactus")}
          </>
        } />
      </div>
    </StyledPricing.Container>
  );
};

export default SeoPricing;